import { render, staticRenderFns } from "./CategoryHierarchyV2.vue?vue&type=template&id=5d96f8ea&scoped=true"
import script from "./CategoryHierarchyV2.vue?vue&type=script&lang=js"
export * from "./CategoryHierarchyV2.vue?vue&type=script&lang=js"
import style0 from "./CategoryHierarchyV2.vue?vue&type=style&index=0&id=5d96f8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96f8ea",
  null
  
)

export default component.exports